/**
 * Bitycle symbols for gold & currency pages: Tehran-market feeds priced in toman (same mapping as TetherApp).
 * Gold bubbles chart their underlying coin; currency variants (farda, sarafi, havale) chart the base currency.
 * The world gold ounce (Market Pulse `ons`, quoted in USD) charts Bitycle's XAUUSD feed, not a toman feed.
 */
export interface AssetChartSymbol {
    symbol: string;
    label: string;
}

const GOLD_SYMBOLS: Record<string, AssetChartSymbol> = {
    ons: { symbol: 'XAUUSD@alpari', label: 'اونس جهانی طلا' },
    xau: { symbol: 'XAUUSD@alpari', label: 'اونس جهانی طلا' },
    geram18: { symbol: 'GOLD18IRT', label: 'طلای ۱۸ عیار' },
    abshodeh: { symbol: 'GOLD18IRT', label: 'طلای ۱۸ عیار' },
    bub_18ayar: { symbol: 'GOLD18IRT', label: 'طلای ۱۸ عیار' },
    geram24: { symbol: 'GOLD24IRT', label: 'طلای ۲۴ عیار' },
    sekee: { symbol: 'IRCOINEMIRT', label: 'سکه امامی' },
    sekee_bubbler: { symbol: 'IRCOINEMIRT', label: 'سکه امامی' },
    sekeb: { symbol: 'IRCOINBAIRT', label: 'سکه بهار آزادی' },
    sekeb_blubber: { symbol: 'IRCOINBAIRT', label: 'سکه بهار آزادی' },
    nim: { symbol: 'IRCOINNIMIRT', label: 'نیم سکه' },
    nim_blubber: { symbol: 'IRCOINNIMIRT', label: 'نیم سکه' },
    rob: { symbol: 'IRCOINROBIRT', label: 'ربع سکه' },
    rob_blubber: { symbol: 'IRCOINROBIRT', label: 'ربع سکه' },
    gerami: { symbol: 'IRCOIN1GIRT', label: 'سکه گرمی' },
    gerami_blubber: { symbol: 'IRCOIN1GIRT', label: 'سکه گرمی' },
};

const CURRENCY_ALIASES: Record<string, string> = {
    usd_farda_buy: 'usd',
    usd_farda_sell: 'usd',
    mex_eur_sell: 'eur',
    gbp_hav: 'gbp',
};

export const getAssetChartSymbol = (
    slug: string,
    symbolType: 'gold' | 'currency',
    displayName?: string,
): AssetChartSymbol => {
    const key = slug.trim().toLowerCase();
    if (symbolType === 'gold') {
        return GOLD_SYMBOLS[key] ?? { symbol: 'GOLD18IRT', label: 'طلای ۱۸ عیار' };
    }
    const base = CURRENCY_ALIASES[key] ?? key;
    return {
        symbol: `${base.toUpperCase()}IRT`,
        label: `${displayName || base.toUpperCase()} به تومان`,
    };
};
